export type DatadogSpan = {
  setTag: (key: string, value: string | number | Record<string, string | number>) => void,
  addTags: (tags: Record<string, string | number>) => void
}
export let tracer: {
  trace: <T extends (span: DatadogSpan) => any>(name: string, fn: T) => ReturnType<T>,
  /** @deprecated not compatible with our lazy-loading strategy, usages will use stub not library */
  wrap: <T extends (...args: any) => any>(name: string, fn: T) => T,
  scope: () => {
    active: () => DatadogSpan
  }
} = {
  trace: (name, fn) => {
    return fn({
      setTag: ()=>{},
      addTags: ()=>{},
    });
  },
  wrap: (name, fn) => fn,
  scope: () => ({
    active: () => ({
      setTag: ()=>{},
      addTags: ()=>{},
    })
  })
};

export function setTypesPackageTracer(_tracer: any) {tracer = _tracer}
